import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TuiSelectLike, TuiTextfield, TuiOptGroup, TuiDataList } from '@taiga-ui/core';
import { TuiInputChip, TuiChevron, TuiMultiSelect, TuiSkeleton } from '@taiga-ui/kit';
import { ComponentsModule } from '@src/app/components';
import { CustomNamesTabsModule } from '@src/app/modules/custom-name-tabs';

import { JobTitleFieldComponent } from './job-title-field.component';

@NgModule({
  declarations: [JobTitleFieldComponent],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsModule,
    ...TuiTextfield,
    ...TuiInputChip,
    ...TuiMultiSelect,
    ...TuiDataList,
    TuiChevron,
    TuiSelectLike,
    TuiOptGroup,
    TuiSkeleton,
    CustomNamesTabsModule,
  ],
  exports: [JobTitleFieldComponent],
})
export class JobTitleFieldModule {}
